import { Component, inject } from '@angular/core';
import { CommonModule, PlatformLocation } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ActionItemComponent } from '../shared/action-item.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'oc-confirm',
  standalone: true,
  imports: [CommonModule, RouterModule, ActionItemComponent],
  template: `
    <div class="modal-container">
      <div class="modal-spacer"></div>
      <div class="modal-body">
        <h1>Confirm</h1>
        <p>Are you sure?</p>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-primary" (click)="onAction(true)">Yes</button>
          <button type="button" class="btn btn-secondary" (click)="onAction(false)">No</button>
        </div>
      </div>
      <div class="modal-spacer">
        <oc-action-item icon="tablerX" size="lg" (click)="activeModal.dismiss('Cross click')"></oc-action-item>
      </div>
    </div>
  `,
  styles: `
    .modal-container {
      display: flex;
    }

    .modal-body {
      flex: 0;
      flex-basis: 560px;
      padding: 2rem;
    }

    .modal-spacer {
      flex: 1; 
    }

    .modal-spacer:last-child {
      padding: 1.5rem;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
    }

    h1 {
      margin-bottom: 2rem;
    }
  `,
})
export class ConfirmComponent {
  private platformLocation = inject(PlatformLocation);
  private modalService = inject(NgbModal);
  public activeModal = inject(NgbActiveModal);

  constructor() {
    this.platformLocation.onPopState(() => this.modalService.dismissAll());
  }

  onAction(confirmed: boolean) {
    this.activeModal.close(confirmed);
  }
}
